import { call, put } from 'redux-saga/effects'
import axios from 'axios'

import { TrainingPolicy } from 'services/api/entities'
import { TrainingPolicyActionCreators } from 'app/reducers/TrainingPolicyRedux'

/**
 * Sube la constancia directo a S3 con el formulario prefirmado.
 *
 * `axios` pelado a proposito: va al bucket, no a nuestra API, asi que no debe
 * llevar el JWT ni los headers por defecto del cliente interno. El navegador
 * escribe el Content-Type con su boundary.
 */
function uploadToS3(presigned, file) {
  const form = new FormData()
  Object.keys(presigned.fields).forEach(key => {
    form.append(key, presigned.fields[key])
  })
  form.append('file', file)
  return axios.post(presigned.url, form)
}

export function* getTrainingPolicyStatusRequest() {
  const response = yield TrainingPolicy.me()

  if (response.success()) {
    return yield put(
      TrainingPolicyActionCreators.getTrainingPolicyStatusSuccess(response.data)
    )
  }
  yield put(
    TrainingPolicyActionCreators.getTrainingPolicyStatusFailure(response.data)
  )
}

export function* getTrainingsRequest({ params }) {
  const response = yield TrainingPolicy.trainings(params)

  if (response.success()) {
    // El endpoint pagina; tolerar tambien un arreglo pelado para que un
    // cambio de paginacion no deje la lista en blanco.
    const { data } = response
    const results = Array.isArray(data) ? data : (data && data.results) || []
    return yield put(
      TrainingPolicyActionCreators.getTrainingsSuccess(results)
    )
  }
  yield put(TrainingPolicyActionCreators.getTrainingsFailure(response.data))
}

/**
 * Tres pasos: pedir el formulario prefirmado, subir el archivo a S3, y recien
 * entonces crear el registro con la llave resultante.
 *
 * El orden importa: si la subida falla, no queda un registro sin constancia
 * esperando una validacion que nadie puede hacer.
 */
export function* createTrainingRequest({ data }) {
  const { evidence, ...fields } = data

  const presignedResponse = yield TrainingPolicy.requestEvidenceUpload()
  if (!presignedResponse.success()) {
    return yield put(
      TrainingPolicyActionCreators.createTrainingFailure(presignedResponse.data)
    )
  }

  const presigned = presignedResponse.data.s3
  try {
    yield call(uploadToS3, presigned, evidence)
  } catch (error) {
    return yield put(
      TrainingPolicyActionCreators.createTrainingFailure({
        evidence: 'No pudimos subir la constancia. Intenta de nuevo.',
      })
    )
  }

  const evidenceKey = presigned.fields.key.replace('${filename}', evidence.name)
  const response = yield TrainingPolicy.createTraining({
    ...fields,
    evidenceKey,
  })

  if (response.success()) {
    yield put(TrainingPolicyActionCreators.createTrainingSuccess(response.data))
    // Refrescar el estado: el alta no mueve las horas (nace pendiente), pero
    // si mueve el listado y la proxima evaluacion que ve el asesor.
    return yield put(
      TrainingPolicyActionCreators.getTrainingPolicyStatusRequest()
    )
  }
  yield put(TrainingPolicyActionCreators.createTrainingFailure(response.data))
}
